import { LoginForm } from './auth';
import { oliveApi } from '../index';

const url = `/v1/auth`;

const loginApi = async (data: LoginForm): Promise<any> => {
  return await oliveApi.POST<LoginForm, any>(`${url}/login`, data);
};

const getProfileApi = async (): Promise<any> => {
  return await oliveApi.GET<void, any>(`/v1/users/me`);
};

export { loginApi, getProfileApi };
